/**
 * POSTs JSON to a `/web-api/auth/*` route, retrying exactly once on 409 WRONG_REGION.
 *
 * That answer carries a `cp_region` cookie, so the edge routes the retry to the
 * user's home region. A second 409 is returned as-is for the caller to display.
 */
export async function postWithRegionRetry(
  url: string,
  body: unknown,
  attempt = 0,
): Promise<Response> {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (res.status === 409 && attempt === 0) {
    const data = await res
      .clone()
      .json()
      .catch(() => null);
    if (data?.code === 'WRONG_REGION') return postWithRegionRetry(url, body, 1);
  }
  return res;
}
